import { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { setToken } from 'core/redux/reducers/userSlice'
import BlockedPage from 'pages/errors/blocked-page'
import BlockedPageOffLine from 'pages/errors/blocked-page-offline'
import ErrorBoundary from 'components/common/error/error-boundary'
import RessourcesProvider from 'core/providers/ressources-provider'
import { validateUserAccess } from 'core/utils/user'
import AppRouter from 'core/routing/router'
import LoadingDialog from '../components/common/loader/loading-progress'
import { useDatadog } from './hooks/useDatadog'
import { useAuth } from 'react-oidc-context'
import { useAuthUserInfo } from './hooks/useAuthUserInfo'
import { useAmplitude } from './hooks/useAmplitude'
import { useTranslation } from 'react-i18next'
import { datadogRum } from '@datadog/browser-rum'

export const App = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const auth = useAuth()
  const userInfo = useAuthUserInfo()

  useEffect(() => {
    const userToken = auth.user?.access_token
    if (validateUserAccess(userToken)) {
      dispatch(setToken(userToken))
    } else if (!auth.isLoading) {
      auth.signinRedirect().catch(error => {
        datadogRum.addError(error)
      })
    }
  }, [auth])

  useEffect(() => {
    return auth.events.addAccessTokenExpiring(() => {
      auth.signinSilent().catch(error => {
        datadogRum.addError(error)
      })
    })
  }, [auth.events, auth.signinSilent])

  useEffect(() => {
    return auth.events.addAccessTokenExpired(() => {
      auth.signinRedirect().catch(error => {
        datadogRum.addError(error)
      })
    })
  }, [auth.events, auth.signinRedirect])

  // Datadog
  useDatadog(auth.isAuthenticated ? userInfo : null)
  useAmplitude(auth.isAuthenticated ? userInfo : null)

  // env var can only be string
  if (import.meta.env.REACT_APP_IS_APP_OFFLINE === 'true') {
    return <BlockedPageOffLine />
  }

  // env var can only be string
  if (import.meta.env.REACT_APP_IS_APP_BLOCKED === 'true') {
    return <BlockedPage title={t('unavailable.title')} content={t('unavailable.content')} />
  }

  if (!auth.isAuthenticated) return <LoadingDialog />

  return (
    <>
      <ErrorBoundary>
        <RessourcesProvider>
          <AppRouter />
        </RessourcesProvider>
      </ErrorBoundary>
    </>
  )
}

export default connect()(App)
